export default function CrossCircleIcon() {
  return (
    <>
      <circle cx='40' cy='40' r='35' fill='url(#paint0_linear_1597_23028)' />
      <path
        d='M40 73.3337C58.4095 73.3337 73.3333 58.4098 73.3333 40.0003C73.3333 21.5908 58.4095 6.66699 40 6.66699C21.5905 6.66699 6.66666 21.5908 6.66666 40.0003C6.66666 58.4098 21.5905 73.3337 40 73.3337Z'
        fill='#FBF3F2'
      />
      <path
        d='M27.6251 27.625L52.3751 52.375M52.3751 27.625L27.6251 52.375'
        stroke='#A0383F'
        strokeWidth='4'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1597_23028'
          x1='40.6076'
          y1='4.0625'
          x2='39.0387'
          y2='72.7124'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#FBF3F2' />
          <stop offset='1' stopColor='#FFEBE7' stopOpacity='0' />
        </linearGradient>
      </defs>
    </>
  );
}
